import React, { Component } from 'react'

// ui
import Modal from '../../components/feedback/modal'
import Button from '../../components/uielements/button'

import { Form, Input, Switch, Select, Upload } from 'antd'
import { FaCheck, FaTimes, FaPlus, FaSave } from 'react-icons/fa'
import { Spin } from 'antd'

// api
import { checkUsername } from '../../services/apis/UserAPIServices'

// redux
import { connect } from 'react-redux'
import userActions from '../../redux/user/actions'

// const
import ListTypeUser from '../../constants/UserRoleConst'

const { Option } = Select
function getBase64(img, callback) {
    const reader = new FileReader()
    reader.addEventListener('load', () => callback(reader.result))
    reader.readAsDataURL(img)
}

class UserInfoForm extends Component {
    state = {
        confirmDirty: false,
        loading: false,
        imageUrl: null,
    }

    handleConfirmBlur = e => {
        const { value } = e.target
        this.setState({ confirmDirty: this.state.confirmDirty || !!value })
    }

    // validator
    validateConfirmPassword = (rule, value, callback) => {
        const { form } = this.props
        if (value && value !== form.getFieldValue('password')) {
            callback('Mật khẩu xác nhận không chính xác')
        } else {
            callback()
        }
    }

    validatePassword = (rule, value, callback) => {
        const { form } = this.props

        if (value && this.state.confirmDirty) {
            form.validateFields(['confirm'], { force: false })
        }

        if (value && value === '') callback('Xin mời bạn nhập mật khẩu')
        if (value && value.length < 6)
            callback('Độ dài tối thiểu của mật khẩu là 6')

        callback()
    }

    validateUsername = async (rule, value, callback) => {
        const { user } = this.props

        if (value && value === '') callback('Xin mời bạn nhập tên đăng nhập')

        if (value.indexOf(' ') !== -1)
            callback('Tên đăng nhập không được chứa khoảng trống')

        if (value) {
            if (user.uid === -1) {
                let response = await checkUsername(value)
                if (response.error.code === 200 && response.data === true)
                    callback('Tên đăng nhập đã tồn tại')
            }
        }

        callback()
    }

    validateOrganization = (rule, value, callback) => {
        console.log('validate organization : ', value)
        if (value) {
            if (value === 0 || value === null)
                callback('Xin mời bạn nhập đơn vị')
        }
        callback()
    }

    // update new props
    componentWillReceiveProps(nextProps) {
        if (nextProps.user !== this.props.user) {
            const { form, user } = nextProps
            //console.log('User info : ', user)
            form.setFieldsValue({ display_name: user.display_name })
            form.setFieldsValue({ user_name: user.user_name })
            form.setFieldsValue({ organ_id: user.organ_id })
            form.setFieldsValue({ tier_id: user.tier_id })
            form.setFieldsValue({ rank_id: user.rank_id })

            form.setFieldsValue({
                password: user.password ? user.password : '',
            })
            if (user.roles)
                form.setFieldsValue({ role: user.roles[0] ? user.roles[0] : 0 })
            form.setFieldsValue({ status: user.status === 1 })
            // this.setState({ imageUrl: user.avatar })
        }
    }

    componentDidMount() {
        const { form, user } = this.props
        //console.log('User info : ', user)
        form.setFieldsValue({ display_name: user.display_name })
        form.setFieldsValue({ user_name: user.user_name })
        form.setFieldsValue({ organ_id: user.organ_id })
        form.setFieldsValue({ tier_id: user.tier_id })
        form.setFieldsValue({ rank_id: user.rank_id })

        form.setFieldsValue({ password: user.password ? user.password : '' })
        if (user.roles)
            form.setFieldsValue({ role: user.roles[0] ? user.roles[0] : 0 })
        form.setFieldsValue({ status: user.status === 1 })
        form.setFieldsValue({ status: user.status === 1 })

        this.setState({ imageUrl: user.avatar })
    }

    handleChange = info => {
        if (info.file.status === 'uploading') {
            this.setState({ loading: true, imageUrl: null })
            return
        }
        if (info.file.status === 'done') {
            this.props.updateAvatarFile(info.file.originFileObj)
            // Get this url from response in real world.
            getBase64(info.file.originFileObj, imageUrl => {
                this.setState({
                    imageUrl,
                    loading: false,
                })
                console.log('image url : ', info.file.originFileObj, imageUrl)
            })
        }
    }

    // event
    onSubmit = e => {
        e.preventDefault()
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.props.dismiss()
                this.props.saveCurrentUser()
            }
        })
    }

    _handleOK = () => {
        this.props.dismiss()
    }

    _handleCancel = () => {
        this.props.dismiss()
    }

    render() {
        const { getFieldDecorator } = this.props.form
        const { user, organizations, updateCurrentUser, roles } = this.props
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        }
        const { imageUrl } = this.state

        const uploadButton = (
            <div>
                {this.state.loading ? <Spin /> : <FaPlus />}
                <div className="ant-upload-text" style={{ fontSize: 13 }}>
                    Upload avatar
                </div>
            </div>
        )
        const dataRank = [
            {
                rank_id: 0,
                rank_name: 'Binh nhì',
            },
            {
                rank_id: 1,
                rank_name: 'Binh nhất',
            },
            {
                rank_id: 2,
                rank_name: 'Hạ sĩ',
            },
            {
                rank_id: 3,
                rank_name: 'Trung sĩ',
            },
            {
                rank_id: 4,
                rank_name: 'Thượng sĩ',
            },
            {
                rank_id: 5,
                rank_name: 'Học viên',
            },
            {
                rank_id: 6,
                rank_name: 'Thiếu úy',
            },
            {
                rank_id: 7,
                rank_name: 'Trung úy',
            },
            {
                rank_id: 8,
                rank_name: 'Thượng úy',
            },
            {
                rank_id: 9,
                rank_name: 'Đại úy',
            },
            {
                rank_id: 10,
                rank_name: 'Thiếu tá',
            },
            {
                rank_id: 11,
                rank_name: 'Trung tá',
            },
            {
                rank_id: 12,
                rank_name: 'Thượng tá',
            },
            {
                rank_id: 13,
                rank_name: 'Đại tá',
            },
            {
                rank_id: 14,
                rank_name: 'Thiếu tướng',
            },
            {
                rank_id: 15,
                rank_name: 'Trung tướng',
            },
            {
                rank_id: 16,
                rank_name: 'Thượng tướng',
            },
            {
                rank_id: 17,
                rank_name: 'Đại tướng',
            },
        ]

        const dummyRequest = ({ file, onSuccess }) => {
            setTimeout(() => {
                onSuccess("ok");
            }, 0);
        };

        return (
            <Form {...formItemLayout} onSubmit={this.onSubmit}>
                <Form.Item
                    label={null}
                    extra={null}
                    style={{ marginLeft: '40%' }}
                >
                    {getFieldDecorator('upload', {})(
                        <Upload
                            name="avatar"
                            showUploadList={false}
                            listType="picture-card"
                            className="avatar-uploader"
                            onChange={this.handleChange}
                            customRequest={dummyRequest}
                            style={{ backgroundColor: 'white' }}
                        >
                            {imageUrl && imageUrl !== '' ? (
                                <img
                                    src={imageUrl}
                                    alt="avatar"
                                    style={{ width: '100%' }}
                                />
                            ) : (
                                    uploadButton
                                )}
                        </Upload>
                    )}
                </Form.Item>

                <Form.Item label="Đơn vị" hasFeedback>
                    {getFieldDecorator('organ_id', {
                        // valuePropName: 'option',
                        rules: [
                            {
                                required: true,
                                message: 'Xin mời chọn đơn vị',
                            },
                            {
                                validator: this.validateOrganization,
                            },
                        ],
                    })(
                        <Select
                            placeholder="Xin mời chọn đơn vị"
                            onChange={value =>
                                updateCurrentUser({ organ_id: value })
                            }
                            value="abbc"
                        // defaultValue={this.getNameOrgDefault()}
                        >
                            {organizations
                                ? organizations.map((organization, index) => {
                                    return (
                                        <Option
                                            value={organization.oid}
                                            key={organization.oid}
                                        >
                                            {organization.name}
                                        </Option>
                                    )
                                })
                                : null}
                            <Option value={0}>Chưa có đơn vị</Option>
                        </Select>
                    )}
                </Form.Item>
                <Form.Item label="Quân hàm" hasFeedback>
                    {getFieldDecorator('rank_id', {
                        // valuePropName: 'option',
                        rules: [
                            {
                                required: true,
                                message: 'Xin mời chọn quân hàm',
                            },
                        ],
                    })(
                        <Select
                            placeholder="Xin mời chọn quân hàm"
                            onChange={value =>
                                updateCurrentUser({ rank_id: value })
                            }
                            value="abbc"
                        // defaultValue={this.getNameOrgDefault()}
                        >
                            {dataRank
                                ? dataRank.map((rank, index) => {
                                    return (
                                        <Option
                                            value={rank.rank_id}
                                            key={index}
                                        >
                                            {rank.rank_name}
                                        </Option>
                                    )
                                })
                                : null}
                        </Select>
                    )}
                </Form.Item>
                <Form.Item label="Tên hiển thị" hasFeedback>
                    {getFieldDecorator('display_name', {
                        trigger: 'onBlur',
                        rules: [
                            {
                                required: true,
                                whitespace: true,
                                message: 'Xin mời nhập tên hiển thị',
                            },
                        ],
                    })(
                        <Input
                            onChange={value =>
                                updateCurrentUser({
                                    display_name: value.target.value,
                                })
                            }
                        />
                    )}
                </Form.Item>
                <Form.Item label="Tên đăng nhập" hasFeedback>
                    {getFieldDecorator('user_name', {
                        trigger: 'onBlur',
                        rules: [
                            {
                                whitespace: true,
                                required: true,
                                message: 'Xin mời nhập tên đăng nhập',
                            },
                            {
                                validator: this.validateUsername,
                            },
                        ],
                    })(
                        <Input
                            onChange={value =>
                                updateCurrentUser({
                                    user_name: value.target.value,
                                })
                            }
                            disabled={user.uid !== -1}
                        />
                    )}
                </Form.Item>

                {this.props.user.uid === -1 ? (
                    <div>
                        <Form.Item label="Mật khẩu" hasFeedback>
                            {getFieldDecorator('password', {
                                // trigger: 'onBlur',
                                rules: [
                                    {
                                        whitespace: true,
                                        required: true,
                                        message: 'Xin mời nhập mật khẩu',
                                    },
                                    {
                                        validator: this.validatePassword,
                                    },
                                ],
                            })(
                                <Input.Password
                                    onChange={value =>
                                        updateCurrentUser({
                                            password: value.target.value,
                                        })
                                    }
                                />
                            )}
                        </Form.Item>
                        <Form.Item label="Xác nhận mật khẩu" hasFeedback>
                            {getFieldDecorator('Xác nhận mật khẩu', {
                                // trigger: 'onBlur',
                                rules: [
                                    {
                                        whitespace: true,
                                        required: true,
                                        message: 'Xin mời xác nhận mật khẩu',
                                    },
                                    {
                                        validator: this.validateConfirmPassword,
                                    },
                                ],
                            })(
                                <Input.Password
                                    onBlur={this.handleConfirmBlur}
                                />
                            )}
                        </Form.Item>
                    </div>
                ) : null}

                <Form.Item label="Loại người dùng">
                    {getFieldDecorator('tier_id', {
                        initialValue: user.tier_id,
                    })(
                        <Select
                            defaultValue={user.tier_id}
                            placeholder="Xin mời chọn quyền người dùng"
                            onChange={value =>
                                updateCurrentUser({ tier_id: value })
                            }
                        >
                            {ListTypeUser.map((role, index) => {
                                return (
                                    <Option key={index} value={role.type}>
                                        {role.name}
                                    </Option>
                                )
                            })}
                        </Select>
                    )}
                </Form.Item>
                <Form.Item label="Quyền người dùng">
                    {getFieldDecorator('role')(
                        <Select
                            placeholder="Xin mời chọn quyền người dùng"
                            onChange={value =>
                                updateCurrentUser({ roles: [value] })
                            }
                        >
                            {roles.map((role, index) => {
                                return (
                                    <Option key={index} value={role.role_id}>
                                        {role.role_name}
                                    </Option>
                                )
                            })}
                        </Select>
                    )}
                </Form.Item>
                <Form.Item label="Kích hoạt tài khoản?">
                    {getFieldDecorator('status', {
                        valuePropName: 'checked',
                        initialValue: user.status === 1,
                    })(
                        <Switch
                            checkedChildren={<FaCheck />}
                            unCheckedChildren={<FaTimes />}
                            onChange={e => {
                                let status = 0
                                if (e === true) status = 1
                                else status = 2
                                updateCurrentUser({ status })
                            }}
                        />
                    )}
                </Form.Item>
                <Form.Item wrapperCol={{ span: 15, offset: 11 }}>
                    <Button
                        size="large"
                        htmlType="submit"
                        style={{
                            backgroundColor: 'lightgreen',
                            marginRight: 5,
                            color: 'black',
                        }}
                    >
                        <FaSave style={{ marginRight: 5 }} />
                        Lưu
                    </Button>

                    <Button
                        size="large"
                        onClick={() => this._handleOK()}
                        style={{ backgroundColor: ' #ffcccc', color: 'black' }}
                    >
                        <FaTimes style={{ marginRight: 5 }} />
                        Huỷ
                    </Button>
                </Form.Item>
            </Form>
        )
    }
}

const mapStateToProps = state => {
    return {
        visible: state.user.modalShowCurrentUserInfoState,
        user: state.user.currentUser,
        organizations: state.organization.organizations,
        roles: state.user.roles,
        isAddNew: state.user.isAddNew,
    }
}

const mapDispatchUserToProps = dispatch => {
    return {
        updateCurrentUser: user => {
            dispatch(userActions.action.updateCurrentUser(user))
        },
        dismiss: () => {
            dispatch(userActions.action.dismissModalCurrentUserInfo())
        },
        saveCurrentUser: () => {
            dispatch(userActions.action.saveCurrentUser())
        },
        updateAvatarFile: file => {
            dispatch(userActions.action.updateAvatarFile(file))
        },
    }
}

const WrappedRegistrationForm = Form.create({ name: 'register' })(UserInfoForm)

const UserForm = connect(
    mapStateToProps,
    mapDispatchUserToProps
)(WrappedRegistrationForm)

class ModalUserInfo extends Component {
    _handleOK = () => {
        this.props.dismiss()
    }

    _handleCancel = () => {
        this.props.dismiss()
    }

    render() {
        const { visible } = this.props

        return (
            <Modal
                maskClosable={false}
                destroyOnClose={true}
                visible={visible}
                title={
                    this.props.isAddNew
                        ? 'Thêm người dùng'
                        : 'Thông tin người dùng '
                }
                onOk={() => this._handleOK()}
                onCancel={() => this._handleCancel()}
                centered
                footer={[]}
            >
                <UserForm />
            </Modal>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dismiss: () => {
            dispatch(userActions.action.dismissModalCurrentUserInfo())
        },
        saveCurrentUser: () => { },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ModalUserInfo)
